import React, { useEffect } from 'react'
import cancel_white from '../assets/images/cancel.png'
import mail from '../assets/images/mail_icon.png'
import whatsapp from '../assets/images/whatsapp_icon.png'
import instagram from '../assets/images/instagram_icon.png'
import facebook from '../assets/images/facebook_icon.png'
import '../assets/css/shareModal.css'

export const ShareModal = (props) => {
    // Use useEffect to add an event listener to the document
    useEffect(() => {
        function onKeyDown(event) {
            if (event.keyCode === 27) {
                // Close the modal when the Escape key is pressed
                props.toggleModal();
            }
        }
        // Prevent scolling
        document.body.style.overflow = "hidden";
        document.addEventListener("keydown", onKeyDown);
        // Clear things up when unmounting this component
        return () => {
            document.body.style.overflow = "visible";
            document.removeEventListener("keydown", onKeyDown);
        };
    });
    // console.log("vin-details = ", props.vinInfo);
    // console.log("Share Link = ", encodeURI(`mailto:?subject=TYV - ${props?.vinName ? props.vinName : "TYV"}&body=Track Your Vehicle. Check this link http://maps.google.com/maps?q=loc:${props?.coords?.lat},${props?.coords?.lng}.`));
    return (
        <>
            <div className="modal__backdrop" >
                <div className="modal__container">
                    <div className="moadal-header-icon-container extraLargeFont">
                        <span>Share</span>
                        <img style={{ cursor: "pointer" }} onClick={props.toggleModal} className="cancel-img" src={cancel_white} alt="cancel" />
                    </div>
                    <div className="horizontal-line" style={{ margin: "1rem 0.25rem" }}></div>
                    <div className="share-container">
                        {/* <div className="share-inner-container-1">Share</div> */}
                        <div className="share-inner-container-2">
                            <a href={`mailto:?subject=TYV - ${props?.vinName ? props.vinName : "TYV"}&body=Track Your Vehicle. Check this link http://maps.google.com/maps?q=loc:${props?.coords?.lat},${props?.coords?.lng}.`} data-action="share/email/share"
                                title="Share by Email" target="_blank" rel="noreferrer"><img className='media-img' src={mail} alt="mail" /></a>

                            <a href={`whatsapp://send?text=http://maps.google.com/maps?q=loc:${props.coords.lat},${props.coords.lng}`} data-action="share/whatsapp/share"
                                title="Share by Whatsapp" target="_blank" rel="noreferrer"><img className='media-img' src={whatsapp} alt="whatsapp" /></a>

                            {/* <a href='www.google.com' target="_blank"><img className='media-img' src={instagram} alt="instagram" /></a> */}
                            {/* <a href='www.google.com' target="_blank"><img className='media-img' src={facebook} alt="facebook" /></a> */}

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};